import { styled } from '@openeducation/oe-it-themes';
import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';

import { PopupPosition } from './popup.types';

interface ArrowProps {
  style?: StyleProp<ViewStyle>;
  popupPosition: PopupPosition;
  width?: number;
  color?: string;
}

export function PopupArrow(props: ArrowProps) {
  return <Arrow {...props} />;
}

const Arrow = styled.View<ArrowProps>`
  width: 0px;
  height: 0px;
  z-index: 10;
  border-style: solid;
  border-left-width: 6px;
  border-right-width: 6px;
  border-bottom-width: 6px;
  position: absolute;
  top: ${({ popupPosition }) =>
    popupPosition.includes('bottom') ? '-5px' : 'auto'};
  bottom: ${({ popupPosition }) =>
    popupPosition.includes('top') ? '-5px' : 'auto'};
  transform: rotate(
    ${({ popupPosition }) =>
      popupPosition.includes('top') ? '180deg' : '0deg'}
  );
  background-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  border-top-color: ${({ theme, color }) =>
    color ?? theme?.color?.border ?? 'white'};
  border-bottom-color: ${({ theme, color }) =>
    color ?? theme?.color?.border ?? 'white'};
  ${({ popupPosition, width = 0 }) => {
    const spacing = width / 2 - 2.5;
    if (popupPosition.includes('left')) {
      return `right: ${spacing}px;`;
    }
    if (popupPosition.includes('right')) {
      return `left: ${spacing}px;`;
    }
    return '';
  }};
`;
